import React from 'react';
import Dashboard from '../../components/Dashboard';
import PageLayout from '../../ui/layout/PageLayout';
import './styles.css';

function DashboardPage() {
  return (
    <PageLayout
      title="Dashboard"
      subtitle="Métricas e visão executiva"
      primary={<Dashboard />}
      secondary={null}
    />
  );
}

export default DashboardPage;
